import numAbbr from 'number-abbreviate';

export default function numAbbreviate(num, minThreshold=1000000, precision=1) {
    const n = parseInt(num);
    return numAbbr(num, (n >= minThreshold ? precision : 0));
};